export const API_OPERATIONS = { GET: 'API_GET' };



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/redux/API/APIConstants.js